module.exports = "<div class=\"csas-branch-header-after\" ng-style=\"vm.style\"></div>\n";